import { getEnvVar, getItem, setItem, removeItem } from '@outlier-org/lst-common-react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { isEmpty } from 'lodash';
import createAuth0Client from '@auth0/auth0-spa-js';
import Cookies from 'js-cookie';
import { create as create$3 } from 'zustand';
import { buildStorage, setupCache } from 'axios-cache-interceptor';
import { openDB } from 'idb';

/**
 * Enum representing the API context.
 */
var ApiContext;
(function (ApiContext) {
  ApiContext["OUTLIER_API"] = "outlier-api";
  ApiContext["AUTH0_API"] = "auth0-api";
  ApiContext["LST_USER_SERVICE"] = "lst-user-service";
  ApiContext["SSO_AUTH_SAPI_SERVICE"] = "sso-auth-sapi-service";
})(ApiContext || (ApiContext = {}));
const AUTH0_TOKEN = 'auth0token';
const AUTH_SCOPE = 'auth-scope';
const IS_SSO_USER = 'is-sso-user';
const SSO_USER_ID = 'sso-user-id';
const SSO_SERVICE_TICKET = 'sso-service-ticket';
const LST_AUTH_TOKEN = 'lst-auth-token';
const LST_AUTH_TOKEN_EXPIRATION = 'lst-auth-token-expiration';
const IS_COOKIE_STORE = 'is-cookie-store';
const LST_API_CACHE_IDB_VERSION = 1;
const LST_API_CACHE_IDB = 'lst-api-cache-idb';
var LstApiCacheStorageType;
(function (LstApiCacheStorageType) {
  LstApiCacheStorageType["LST_OUTLIER_API_CACHE_STORAGE"] = "lst-outlier-api-cache-storage";
  LstApiCacheStorageType["LST_AUTH0_API_CACHE_STORAGE"] = "lst-auth0-api-cache-storage";
  LstApiCacheStorageType["LST_USER_SERVICE_CACHE_STORAGE"] = "lst-user-service-cache-storage";
})(LstApiCacheStorageType || (LstApiCacheStorageType = {}));
const OUTLIER_API_CACHE_STORAGE_TTL = getEnvVar('REACT_APP_OUTLIER_API_CACHE_STORAGE_TTL');
const LST_API_CACHE_STORAGE_TTL = 15 * 60 * 1000; // 15 minutes
const LST_API_CACHE_METHODS = ['get', 'post'];
const SET_COOKIE_OPTIONS = {
  expires: 1,
  sameSite: 'None',
  secure: true
};

/**
 * The API configuration for the Outlier API.
 *
 * This enum contains the API endpoints used by the Outlier API.
 *
 * @enum {string}
 */
var OutlierApiConfig;
(function (OutlierApiConfig) {
  OutlierApiConfig["GET_ADMIN_ACCESS_PERMISSIONS"] = "/admin/access/permissions";
  OutlierApiConfig["UPDATE_AUTH0_USER"] = "/update/auth0/user";
  OutlierApiConfig["GET_STUDENT_ID"] = "/student/student-id";
  OutlierApiConfig["COLLEGE_SUCCESS_COURSE_ENROLL"] = "/student/college-success/enroll";
})(OutlierApiConfig || (OutlierApiConfig = {}));
/**
 * The SAPI API configuration.
 *
 * This enum contains the API endpoints used by the SAPI API.
 *
 * @enum {string}
 */
var SapiApiConfig;
(function (SapiApiConfig) {
  SapiApiConfig["LOGIN"] = "/account/v2/login";
  SapiApiConfig["CASTGC_TOKEN"] = "/oauth/token";
  SapiApiConfig["REVOKE_OAUTH_TOKEN"] = "/oauth/token/revoke";
  SapiApiConfig["RESET_TOKEN_TTL"] = "/oauth/token/reset_ttl";
})(SapiApiConfig || (SapiApiConfig = {}));
/**
 * The User API configuration.
 *
 * This enum contains the API endpoints used by the User API.
 *
 * @enum {string}
 */
var UserApiConfig;
(function (UserApiConfig) {
  UserApiConfig["USER_DETAILS"] = "/ups/api/v2/user";
})(UserApiConfig || (UserApiConfig = {}));
const X_AUTHORIZATION = 'Authorization';
const X_AUTH_PROVIDER = 'x-auth-provider';
var AuthProviderType;
(function (AuthProviderType) {
  AuthProviderType["AUTH0"] = "auth0";
  AuthProviderType["RUMBA_SSO"] = "rumba-sso";
})(AuthProviderType || (AuthProviderType = {}));
const X_USER_EMAIL = 'x-user-email';
const CONTENT_TYPE = 'Content-Type';
const APPLICATION_JSON = 'application/json';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$i = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$h = fails$i;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$g = fails$i;

var functionBindNative = !fails$g(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$b = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var functionCall = NATIVE_BIND$1 ? call$b.bind(call$b) : function () {
  return call$b.apply(call$b, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$a = FunctionPrototype$1.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$a, call$a);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$a.apply(fn, arguments);
  };
};

var uncurryThis$e = functionUncurryThis;

var toString$7 = uncurryThis$e({}.toString);
var stringSlice$2 = uncurryThis$e(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$2(toString$7(it), 8, -1);
};

var uncurryThis$d = functionUncurryThis;
var fails$f = fails$i;
var classof$4 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$d(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$f(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (isNullOrUndefined$1(it)) throw new $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$5(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$f = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$e = isCallable$f;

var isObject$a = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var globalThis$g = globalThis_1;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$g[namespace]) : globalThis$g[namespace] && globalThis$g[namespace][method];
};

var uncurryThis$c = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$c({}.isPrototypeOf);

var globalThis$f = globalThis_1;

var navigator = globalThis$f.navigator;
var userAgent$1 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$1 ? String(userAgent$1) : '';

var globalThis$e = globalThis_1;
var userAgent = environmentUserAgent;

var process = globalThis$e.process;
var Deno = globalThis$e.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = environmentV8Version;
var fails$e = fails$i;
var globalThis$d = globalThis_1;

var $String$5 = globalThis$d.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$e(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$c = isCallable$f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw new $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$2 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};

var call$9 = functionCall;
var isCallable$a = isCallable$f;
var isObject$9 = isObject$a;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$9(val = call$9(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$9(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$9(val = call$9(fn, input))) return val;
  throw new $TypeError$6("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var globalThis$c = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$5(globalThis$c, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$c[key] = value;
  } return value;
};

var globalThis$b = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$b[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.42.0',
  mode: 'global',
  copyright: '© 2014-2025 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.42.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$4 = requireObjectCoercible$6;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$2(requireObjectCoercible$4(argument));
};

var uncurryThis$b = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$b({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$a = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$6 = uncurryThis$a(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id + postfix, 36);
};

var globalThis$a = globalThis_1;
var shared$3 = shared$4;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$a.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$b = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$9(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$8 = functionCall;
var isObject$8 = isObject$a;
var isSymbol$1 = isSymbol$2;
var getMethod$1 = getMethod$2;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$a = wellKnownSymbol$b;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$a('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$8(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$1(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$8(result) || isSymbol$1(result)) return result;
    throw new $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var globalThis$9 = globalThis_1;
var isObject$7 = isObject$a;

var document$1 = globalThis$9.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$7(document$1) && isObject$7(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$d = fails$i;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$8 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$7 = descriptors;
var fails$c = fails$i;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$7 && fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$6 = isObject$a;

var $String$3 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$8 = function (argument) {
  if (isObject$6(argument)) return argument;
  throw new $TypeError$4($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$7 = anObject$8;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$9 = functionUncurryThis;
var isCallable$9 = isCallable$f;
var store$1 = sharedStore.exports;

var functionToString = uncurryThis$9(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var globalThis$8 = globalThis_1;
var isCallable$8 = isCallable$f;

var WeakMap$1 = globalThis$8.WeakMap;

var weakMapBasicDetection = isCallable$8(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$7 = globalThis_1;
var isObject$5 = isObject$a;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$6 = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis$7.TypeError;
var WeakMap = globalThis$7.WeakMap;
var set, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get$1(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$8 = functionUncurryThis;
var fails$b = fails$i;
var isCallable$7 = isCallable$f;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;
var stringSlice$1 = uncurryThis$8(''.slice);
var replace$2 = uncurryThis$8(''.replace);
var join = uncurryThis$8([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$b(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (stringSlice$1($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$2($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$7(this) && getInternalState$2(this).source || inspectSource(this);
}, 'toString');

var isCallable$6 = isCallable$f;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$5 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$6(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$7 = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$7([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf$1(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$6 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$6 = anObject$8;

var concat$1 = uncurryThis$6([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$a = fails$i;
var isCallable$5 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$5(detection) ? fails$a(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var globalThis$6 = globalThis_1;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$4 = defineBuiltIn$5;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$6;
  } else if (STATIC) {
    target = globalThis$6[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$6[TARGET] && globalThis$6[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$4(target, key, sourceProperty, options);
  }
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$5 = anObject$8;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$5(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$4 = anObject$8;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$4(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$9 = wellKnownSymbol$b;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$9('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$5 = _export;
var $includes = arrayIncludes.includes;
var fails$9 = fails$i;
var addToUnscopables$1 = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$9(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$5({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var DESCRIPTORS$1 = descriptors;
var uncurryThis$5 = functionUncurryThis;
var call$6 = functionCall;
var fails$8 = fails$i;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat = uncurryThis$5([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$8(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$1 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$1 || call$6(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$4 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$4({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var wellKnownSymbol$8 = wellKnownSymbol$b;

var TO_STRING_TAG$2 = wellKnownSymbol$8('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$4 = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol$7 = wellKnownSymbol$b;

var TO_STRING_TAG$1 = wellKnownSymbol$7('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$3 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable$4(O.callee) ? 'Arguments' : result;
};

var classof$2 = classof$3;

var $String$1 = String;

var toString$5 = function (argument) {
  if (classof$2(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$4 = functionUncurryThis;
var requireObjectCoercible$3 = requireObjectCoercible$6;
var toString$4 = toString$5;
var whitespaces$1 = whitespaces$2;

var replace$1 = uncurryThis$4(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$4(requireObjectCoercible$3($this));
    if (TYPE & 1) string = replace$1(string, ltrim, '');
    if (TYPE & 2) string = replace$1(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var globalThis$5 = globalThis_1;
var fails$7 = fails$i;
var uncurryThis$3 = functionUncurryThis;
var toString$3 = toString$5;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = globalThis$5.parseInt;
var Symbol$1 = globalThis$5.Symbol;
var ITERATOR$3 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$1 = uncurryThis$3(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$3 && !fails$7(function () { $parseInt$1(Object(ITERATOR$3)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString$3(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$1(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$3 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$3({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

let client;
/**
 * Asynchronously initializes and returns an Auth0 client instance.
 *
 * This function checks if the client is already initialized and returns it if so.
 * Otherwise, it retrieves necessary environment variables, creates the Auth0 client,
 * and attaches a method to retrieve the ID token silently.
 *
 * @throws {Error} If `REACT_APP_DOMAIN` or `REACT_APP_CLIENT_ID` are not defined in the environment variables.
 *
 * @returns {Promise<Auth0Client>} A promise that resolves to the initialized Auth0 client instance.
 */
const getAuth0Client = () => __awaiter(void 0, void 0, void 0, function* () {
  if (client) return client;
  const domain = getEnvVar('REACT_APP_DOMAIN');
  const clientId = getEnvVar('REACT_APP_CLIENT_ID');
  if (!domain || !clientId) {
    throw new Error('Please define REACT_APP_DOMAIN and REACT_APP_CLIENT_ID in your .env file');
  }
  client = yield createAuth0Client({
    domain,
    client_id: clientId,
    audience: getEnvVar('REACT_APP_AUTH0_AUDIENCE'),
    responseType: 'token id_token'
  });
  client.getIdToken = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield client.getTokenSilently({
      detailedResponse: true
    });
    return response.id_token;
  });
  return client;
});
const isCookieStore = () => Cookies.get(IS_COOKIE_STORE) === 'true';
const getSsoUserId = () => {
  const isCookieStoreEnabled = isCookieStore();
  if (isCookieStoreEnabled) {
    return Cookies.get(SSO_USER_ID);
  }
  return getItem(SSO_USER_ID) || '';
};
const getAuthTokenFromStore = () => {
  const isCookieStoreEnabled = isCookieStore();
  if (isCookieStoreEnabled) {
    return Cookies.get(LST_AUTH_TOKEN);
  }
  return getItem(LST_AUTH_TOKEN) || '';
};
const getTokenExpiration = () => {
  const isCookieStoreEnabled = isCookieStore();
  if (isCookieStoreEnabled) {
    return parseInt(Cookies.get(LST_AUTH_TOKEN_EXPIRATION) || '0');
  }
  return parseInt(getItem(LST_AUTH_TOKEN_EXPIRATION) || '0');
};
const getServiceTicket = () => {
  const isCookieStoreEnabled = isCookieStore();
  if (isCookieStoreEnabled) {
    return Cookies.get(SSO_SERVICE_TICKET);
  }
  return getItem(SSO_SERVICE_TICKET) || '';
};

var anObject$3 = anObject$8;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$3(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$5 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$2(R, 'flags') && isPrototypeOf(RegExpPrototype$2, R)
    ? call$5(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$5;
var anObject$2 = anObject$8;
var $toString = toString$5;
var fails$6 = fails$i;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$6(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$2(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

/**
 * Custom hook to manage authentication tokens and service tickets using Zustand and Cookies.
 *
 * @returns {LstAuthTokenStore} The store containing authentication tokens and service tickets.
 *
 * @property {string | undefined} authToken - The authentication token retrieved from cookies.
 * @property {string | undefined} serviceTicket - The service ticket retrieved from cookies.
 * @property {string | undefined} tokenExpiration - The token expiration time retrieved from cookies.
 *
 * @method setAuthToken - Sets the authentication token in cookies and updates the store.
 * @param {string} authToken - The authentication token to be set.
 *
 * @method clearAuthToken - Clears the authentication token from cookies and updates the store.
 *
 * @method setTokenExpiration - Sets the token expiration time in cookies and updates the store.
 * @param {number} tokenExpiration - The token expiration time to be set.
 *
 * @method clearTokenExpiration - Clears the token expiration time from cookies and updates the store.
 *
 * @method setServiceTicket - Sets the service ticket in cookies and updates the store.
 * @param {string} serviceTicket - The service ticket to be set.
 *
 * @method clearServiceTicket - Clears the service ticket from cookies and updates the store.
 *
 * @method clearAll - Clears all tokens and service tickets from cookies and updates the store.
 */
const useLstAuthTokenStore = create$3((set, get) => ({
  storeKeys: [LST_AUTH_TOKEN, LST_AUTH_TOKEN_EXPIRATION, SSO_USER_ID, SSO_SERVICE_TICKET],
  isCookieStore: isCookieStore(),
  setCookieStore: isCookieStore => {
    if (isCookieStore) {
      get().setSessionCookies();
    } else {
      get().setSessionLocalStore();
      get().clearSessionCookies();
    }
    Cookies.set(IS_COOKIE_STORE, isCookieStore.toString(), SET_COOKIE_OPTIONS);
    set({
      isCookieStore
    });
  },
  ssoUserId: getSsoUserId(),
  setSsoUserId: ssoUserId => {
    const isCookieStore = get().isCookieStore;
    if (isCookieStore) {
      Cookies.set(SSO_USER_ID, ssoUserId, SET_COOKIE_OPTIONS);
    } else {
      setItem(SSO_USER_ID, ssoUserId);
    }
    set({
      ssoUserId
    });
  },
  clearSsoUserId: () => {
    Cookies.remove(SSO_USER_ID);
    set({
      ssoUserId: undefined
    });
  },
  authToken: getAuthTokenFromStore(),
  setAuthToken: authToken => {
    const isCookieStore = get().isCookieStore;
    if (isCookieStore) {
      Cookies.set(LST_AUTH_TOKEN, authToken, SET_COOKIE_OPTIONS);
    } else {
      setItem(LST_AUTH_TOKEN, authToken);
    }
    set({
      authToken
    });
  },
  clearAuthToken: () => {
    Cookies.remove(LST_AUTH_TOKEN);
    set({
      authToken: undefined
    });
  },
  tokenExpiration: getTokenExpiration(),
  setTokenExpiration: tokenExpiration => {
    const isCookieStore = get().isCookieStore;
    if (isCookieStore) {
      Cookies.set(LST_AUTH_TOKEN_EXPIRATION, tokenExpiration.toString(), SET_COOKIE_OPTIONS);
    } else {
      setItem(LST_AUTH_TOKEN_EXPIRATION, tokenExpiration.toString());
    }
    set({
      tokenExpiration
    });
  },
  clearTokenExpiration: () => {
    Cookies.remove(LST_AUTH_TOKEN_EXPIRATION);
    set({
      tokenExpiration: undefined
    });
  },
  serviceTicket: getServiceTicket(),
  setServiceTicket: serviceTicket => {
    const isCookieStore = get().isCookieStore;
    if (isCookieStore) {
      Cookies.set(SSO_SERVICE_TICKET, serviceTicket, SET_COOKIE_OPTIONS);
    } else {
      setItem(SSO_SERVICE_TICKET, serviceTicket);
    }
    set({
      serviceTicket
    });
  },
  clearServiceTicket: () => {
    Cookies.remove(SSO_SERVICE_TICKET);
    removeItem(SSO_SERVICE_TICKET);
    set({
      serviceTicket: undefined
    });
  },
  setSessionCookies: () => {
    const ssoUserId = get().ssoUserId;
    const authToken = get().authToken;
    const tokenExpiration = get().tokenExpiration;
    const serviceTicket = get().serviceTicket;
    Cookies.set(SSO_USER_ID, ssoUserId, SET_COOKIE_OPTIONS);
    Cookies.set(LST_AUTH_TOKEN, authToken, SET_COOKIE_OPTIONS);
    Cookies.set(LST_AUTH_TOKEN_EXPIRATION, tokenExpiration.toString(), SET_COOKIE_OPTIONS);
    Cookies.set(SSO_SERVICE_TICKET, serviceTicket, SET_COOKIE_OPTIONS);
  },
  setSessionLocalStore: () => {
    const ssoUserId = get().ssoUserId;
    const authToken = get().authToken;
    const tokenExpiration = get().tokenExpiration;
    const serviceTicket = get().serviceTicket;
    if (isEmpty(authToken)) {
      return;
    }
    setItem(SSO_USER_ID, ssoUserId);
    setItem(LST_AUTH_TOKEN, authToken);
    setItem(LST_AUTH_TOKEN_EXPIRATION, tokenExpiration);
    setItem(SSO_SERVICE_TICKET, serviceTicket);
  },
  clearSessionCookies: () => {
    const storeKeys = get().storeKeys;
    storeKeys.forEach(key => {
      Cookies.remove(key);
    });
  },
  clearAll: () => {
    const storeKeys = get().storeKeys.filter(key => key !== SSO_SERVICE_TICKET);
    storeKeys.forEach(key => {
      Cookies.remove(key);
      removeItem(key);
    });
    set({
      ssoUserId: undefined,
      authToken: undefined,
      tokenExpiration: undefined,
      serviceTicket: undefined
    });
  }
}));

/**
 * Asynchronously retrieves the Auth0 token.
 *
 * This function initializes the Auth0 client and checks if the user is authenticated.
 * If the user is authenticated and the client has an ID token, it retrieves and returns the token.
 * If the user is not authenticated or the client does not have an ID token, it returns null.
 *
 * @returns {Promise<string | null>} A promise that resolves to the Auth0 token if available, otherwise null.
 */
const getAuth0Token = () => __awaiter(void 0, void 0, void 0, function* () {
  const auth0Token = useLstAuthTokenStore.getState().authToken;
  if (auth0Token) {
    return auth0Token;
  }
  const client = yield getAuth0Client();
  const isAuthenticated = yield client.isAuthenticated();
  if (!isAuthenticated || !client.getIdToken) {
    return null;
  }
  const token = yield client.getIdToken();
  return token;
});
/**
 * Retrieves the authentication token based on the SSO (Single Sign-On) configuration.
 *
 * If SSO is enabled, it retrieves the RBS token from local storage.
 * Otherwise, it retrieves the Auth0 token using the Auth0 client.
 *
 * @returns {Promise<string | undefined>} A promise that resolves to the authentication token if available, otherwise undefined.
 */
const getAuthToken = () => __awaiter(void 0, void 0, void 0, function* () {
  const authToken = useLstAuthTokenStore.getState().authToken;
  return authToken;
});
/**
 * Asynchronously retrieves authentication headers.
 *
 * This function fetches an authentication token and constructs the `Authorization`
 * header using the token. It also merges the static headers with the authorization header.
 *
 * @returns {Promise<{ [key: string]: string }>} A promise that resolves to an object containing
 * the authentication headers.
 */
const getAuthHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
  const token = yield getAuthToken();
  const isSsoEnabled = getItem(IS_SSO_USER);
  const headers = {};
  if (token) {
    headers[X_AUTHORIZATION] = `Bearer ${token}`;
  }
  if (!isSsoEnabled) {
    return headers;
  }
  const userId = useLstAuthTokenStore.getState().ssoUserId || '';
  return Object.assign(Object.assign({}, headers), {
    userId,
    userIds: userId
  });
});
/**
 * Retrieves the headers required for Outlier API requests.
 *
 * This function fetches the authentication headers and determines if SSO (Single Sign-On) is enabled.
 * If SSO is enabled, it adds the appropriate SSO headers. Otherwise, it adds the Auth0 headers.
 *
 * @returns {Promise<AxiosRequestHeaders>} A promise that resolves to the headers object.
 */
const getOutlierApiHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
  const headers = yield getAuthHeaders();
  const isSsoEnabled = getItem(IS_SSO_USER);
  if (isSsoEnabled) {
    headers[X_AUTH_PROVIDER] = AuthProviderType.RUMBA_SSO;
    headers[X_USER_EMAIL] = getItem(X_USER_EMAIL);
  } else {
    headers[X_AUTH_PROVIDER] = AuthProviderType.AUTH0;
  }
  return headers;
});
/**
 * Retrieves static headers for HTTP requests.
 *
 * These headers are used to control caching behavior and ensure that the responses
 * are not cached by the browser or any intermediate caches.
 *
 * @returns {Record<string, string>} An object containing the static headers.
 */
const getStaticHeaders = () => ({
  [CONTENT_TYPE]: APPLICATION_JSON
});

var fails$5 = fails$i;
var globalThis$4 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$4.RegExp;

var UNSUPPORTED_Y$1 = fails$5(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$5(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$5(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$4 = fails$i;
var globalThis$3 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$3.RegExp;

var regexpUnsupportedDotAll = fails$4(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$3 = fails$i;
var globalThis$2 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$2.RegExp;

var regexpUnsupportedNcg = fails$3(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$4 = functionCall;
var uncurryThis$2 = functionUncurryThis;
var toString$2 = toString$5;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create$1 = objectCreate;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis$2(''.charAt);
var indexOf = uncurryThis$2(''.indexOf);
var replace = uncurryThis$2(''.replace);
var stringSlice = uncurryThis$2(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$4(nativeExec, re1, 'a');
  call$4(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$4(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$4(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$4(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$4(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$1(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$2 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$2({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$3 = functionCall;
var defineBuiltIn$2 = defineBuiltIn$5;
var regexpExec$1 = regexpExec$2;
var fails$2 = fails$i;
var wellKnownSymbol$6 = wellKnownSymbol$b;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol$6('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$6(KEY);

  var DELEGATES_TO_SYMBOL = !fails$2(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$2(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$3(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$3(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$2(String.prototype, KEY, methods[0]);
    defineBuiltIn$2(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$2(RegExpPrototype[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call$2 = functionCall;
var anObject$1 = anObject$8;
var isCallable$3 = isCallable$f;
var classof$1 = classofRaw$1;
var regexpExec = regexpExec$2;

var $TypeError$2 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$3(exec)) {
    var result = call$2(exec, R, S);
    if (result !== null) anObject$1(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$2(regexpExec, R, S);
  throw new $TypeError$2('RegExp#exec called on incompatible receiver');
};

var call$1 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$8;
var isObject$4 = isObject$a;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var sameValue = sameValue$1;
var toString$1 = toString$5;
var getMethod = getMethod$2;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = isObject$4(regexp) ? getMethod(regexp, SEARCH) : undefined;
      return searcher ? call$1(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$1(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString$1(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

(function (exports) {
const strictUriEncode$1 = strictUriEncode;
const decodeComponent = decodeUriComponent;
const splitOnFirst$1 = splitOnFirst;
const filterObject = filterObj;

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst$1(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
}(queryString));

const getOutlierApiBaseURL = () => {
  let apiHostFromLocalStorage = localStorage['apiHost'];
  const apiHostFromURL = window.location.search && queryString.parse(window.location.search.slice(1))['apiHost'];
  if (!apiHostFromLocalStorage && !apiHostFromURL) {
    return getEnvVar('REACT_APP_OUTLIER_API_BASE_URL');
  }
  if (apiHostFromURL) {
    localStorage['apiHost'] = apiHostFromURL;
    apiHostFromLocalStorage = apiHostFromURL;
  }
  return apiHostFromLocalStorage;
};
const getOutlierApiPath = path => {
  const apiBaseUrl = getOutlierApiBaseURL();
  return `${apiBaseUrl}${path}`;
};
const getAuth0BaseUrl = () => `https://${getEnvVar('REACT_APP_DOMAIN')}`;
const getSsoAuthSapiBaseURL = () => getEnvVar('REACT_APP_SSO_AUTH_SAPI_BASE_URL');
const getLstUserServiceBaseURL = () => getEnvVar('REACT_APP_LST_USER_SERVICE_BASE_URL');

var iterators = {};

var fails$1 = fails$i;

var correctPrototypeGetter = !fails$1(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$1 = hasOwnProperty_1;
var isCallable$2 = isCallable$f;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$2(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails = fails$i;
var isCallable$1 = isCallable$f;
var isObject$3 = isObject$a;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$1 = defineBuiltIn$5;
var wellKnownSymbol$5 = wellKnownSymbol$b;

var ITERATOR$2 = wellKnownSymbol$5('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$3(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$1(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$1(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol$4 = wellKnownSymbol$b;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');

var setToStringTag$3 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty$1(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$1 = functionUncurryThis;
var aCallable = aCallable$2;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$1(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$2 = isObject$a;

var isPossiblePrototype$1 = function (argument) {
  return isObject$2(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String = String;
var $TypeError$1 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$1("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$1 = isObject$a;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$1(O);
    aPossiblePrototype(proto);
    if (!isObject$1(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$1 = _export;
var call = functionCall;
var FunctionName = functionName;
var isCallable = isCallable$f;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var defineBuiltIn = defineBuiltIn$5;
var wellKnownSymbol$3 = wellKnownSymbol$b;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$3('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var isObject = isObject$a;
var classof = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$b;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$b;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$6;
var toString = toString$5;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$1 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var setToStringTag = setToStringTag$3;
var wellKnownSymbol = wellKnownSymbol$b;

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$1[COLLECTION_NAME] && globalThis$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const useLstApiCacheStore = create$3((set, get) => ({
  cacheStorage: {},
  setCacheStorage: cacheStorage => set({
    cacheStorage
  }),
  setCacheKey: (key, value, apiContext = ApiContext.OUTLIER_API) => __awaiter(void 0, void 0, void 0, function* () {
    const lstApiCacheStorage = yield get().cacheStorage[apiContext];
    yield lstApiCacheStorage.set(key, value);
  }),
  getCacheKey: (key, apiContext = ApiContext.OUTLIER_API) => __awaiter(void 0, void 0, void 0, function* () {
    const lstApiCacheStorage = yield get().cacheStorage[apiContext];
    return yield lstApiCacheStorage.get(key);
  }),
  deleteCacheKey: (key, apiContext = ApiContext.OUTLIER_API) => __awaiter(void 0, void 0, void 0, function* () {
    const lstApiCacheStorage = yield get().cacheStorage[apiContext];
    yield lstApiCacheStorage.remove(key);
  }),
  removeCacheStorage: (apiContext, excludeKeys = []) => __awaiter(void 0, void 0, void 0, function* () {
    const lstApiCacheStorage = yield get().cacheStorage[apiContext];
    if (excludeKeys.length === 0) {
      lstApiCacheStorage.clear();
      return;
    }
    const allKeys = yield lstApiCacheStorage.getAllKeys();
    for (const key of allKeys) {
      if (!excludeKeys.includes(key)) {
        yield lstApiCacheStorage.remove(key);
      }
    }
  }),
  removeAllCacheStoages: () => __awaiter(void 0, void 0, void 0, function* () {
    const cacheStorage = get().cacheStorage;
    for (const key in cacheStorage) {
      const lstApiCacheStorage = cacheStorage[key];
      yield lstApiCacheStorage.clear();
    }
  })
}));

/**
 * Initializes the LST API cache storage using the specified storage type.
 *
 * @param lstApiCacheStorageType - The type of storage to be used for caching.
 * @returns A promise that resolves to an instance of `LstAxiosStorage`.
 *
 * The returned `LstAxiosStorage` instance provides methods to interact with the cache:
 * - `find(key: string): Promise<any>`: Retrieves the value associated with the given key.
 * - `set(key: string, value: any): Promise<void>`: Stores the value with the associated key.
 * - `remove(key: string): Promise<void>`: Removes the value associated with the given key.
 * - `clear(): Promise<void>`: Clears all entries in the cache.
 */
const initLstApiCacheStorage = lstApiCacheStorageType => __awaiter(void 0, void 0, void 0, function* () {
  const lstApiCacheIdb = yield openDB(LST_API_CACHE_IDB, LST_API_CACHE_IDB_VERSION, {
    upgrade(db) {
      db.createObjectStore(lstApiCacheStorageType);
    }
  });
  const lstApiCacheStorage = Object.assign(Object.assign({}, buildStorage({
    find(key) {
      return __awaiter(this, void 0, void 0, function* () {
        return yield lstApiCacheIdb.get(lstApiCacheStorageType, key);
      });
    },
    set(key, value) {
      return __awaiter(this, void 0, void 0, function* () {
        yield lstApiCacheIdb.put(lstApiCacheStorageType, value, key);
      });
    },
    remove(key) {
      return __awaiter(this, void 0, void 0, function* () {
        yield lstApiCacheIdb.delete(lstApiCacheStorageType, key);
      });
    }
  })), {
    clear: () => __awaiter(void 0, void 0, void 0, function* () {
      yield lstApiCacheIdb.clear(lstApiCacheStorageType);
    }),
    getAllKeys: () => lstApiCacheIdb.getAllKeys(lstApiCacheStorageType)
  });
  return lstApiCacheStorage;
});
/**
 * Retrieves the appropriate cache storage type based on the provided API context.
 *
 * @param apiContext - The context of the API for which the cache storage type is needed.
 * @returns The corresponding cache storage type for the given API context, or null if the context is not recognized.
 */
const getLstApiCacheStorageType = apiContext => {
  switch (apiContext) {
    case ApiContext.OUTLIER_API:
      return LstApiCacheStorageType.LST_OUTLIER_API_CACHE_STORAGE;
    case ApiContext.LST_USER_SERVICE:
      return LstApiCacheStorageType.LST_USER_SERVICE_CACHE_STORAGE;
    default:
      return null;
  }
};
/**
 * Sets up the LST API cache for the specified API context.
 *
 * @param {ApiContext} [apiContext=ApiContext.OUTLIER_API] - The API context to use for the cache.
 * @param {number} [ttl=LST_API_CACHE_STORAGE_TTL] - The time-to-live (TTL) for the cache storage.
 * @param {string[]} [methods=LST_API_CACHE_METHODS] - The HTTP methods to cache.
 * @returns {Promise<void>} A promise that resolves when the cache setup is complete.
 */
const setupLstApiCache = (apiContext = ApiContext.OUTLIER_API, ttl = LST_API_CACHE_STORAGE_TTL, methods = LST_API_CACHE_METHODS) => __awaiter(void 0, void 0, void 0, function* () {
  const cacheStorageType = getLstApiCacheStorageType(apiContext);
  if (!cacheStorageType) {
    return;
  }
  const lstApiCacheStorage = yield initLstApiCacheStorage(cacheStorageType);
  const axiosInstance = getAxiosInstance(apiContext);
  const {
    cacheStorage,
    setCacheStorage
  } = useLstApiCacheStore.getState();
  setupCache(axiosInstance, {
    ttl,
    methods,
    storage: lstApiCacheStorage
  });
  cacheStorage[apiContext] = lstApiCacheStorage;
  setCacheStorage(cacheStorage);
});
/**
 * Clears the LST API cache for the specified API context.
 *
 * @param {ApiContext} [apiContext=ApiContext.OUTLIER_API] - The API context for which the cache should be cleared. Defaults to `ApiContext.OUTLIER_API`.
 * @returns {Promise<void>} A promise that resolves when the cache has been cleared.
 */
const clearLstApiCache = (apiContext = ApiContext.OUTLIER_API) => __awaiter(void 0, void 0, void 0, function* () {
  const {
    cacheStorage,
    removeCacheStorage
  } = useLstApiCacheStore.getState();
  const lstApiCacheStorage = cacheStorage[apiContext];
  if (lstApiCacheStorage) {
    yield removeCacheStorage(apiContext);
  }
});
/**
 * Clears all cache storages by invoking the `removeAllCacheStoages` method
 * from the `useLstApiCacheStore` state.
 *
 * @async
 * @function clearAllCacheStoages
 * @returns {Promise<void>} A promise that resolves when all cache storages are cleared.
 */
const clearAllCacheStoages = () => __awaiter(void 0, void 0, void 0, function* () {
  const {
    removeAllCacheStoages
  } = useLstApiCacheStore.getState();
  removeAllCacheStoages();
});

/**
 * An Axios instance configured with the base URL for the Outlier API.
 * This instance can be used to make HTTP requests to the Outlier API endpoints.
 *
 * @constant
 * @type {AxiosInstance}
 */
const outlierApiInstance = axios.create({
  baseURL: getOutlierApiBaseURL()
});
/**
 * An Axios interceptor that adds the authentication headers to the request.
 * This interceptor is used to add the authentication headers to all requests
 * made using the `outlierApiInstance`.
 *
 * @function
 */
outlierApiInstance.interceptors.request.use(config => __awaiter(void 0, void 0, void 0, function* () {
  const defaultHeaders = yield getOutlierApiHeaders();
  const headers = Object.assign(Object.assign({}, defaultHeaders), config.headers);
  return Object.assign(Object.assign({}, config), {
    headers
  });
}));
(() => __awaiter(void 0, void 0, void 0, function* () {
  yield setupLstApiCache(ApiContext.OUTLIER_API);
}))();

/**
 * An Axios instance configured with the base URL for the SSO Auth SAPI API.
 * This instance can be used to make HTTP requests to the SSO Auth SAPI API endpoints.
 *
 * @constant
 * @type {AxiosInstance}
 */
const ssoAuthSapiApiInstance = axios.create({
  baseURL: getSsoAuthSapiBaseURL()
});

/**
 * An Axios instance configured with the base URL for the LST User Service API.
 * This instance can be used to make HTTP requests to the LST User Service API endpoints.
 *
 * @constant
 * @type {AxiosInstance}
 */
const lstUserServiceApiInstance = axios.create({
  baseURL: getLstUserServiceBaseURL()
});
/**
 * An Axios interceptor that adds the authentication headers to the request.
 * This interceptor is used to add the authentication headers to all requests
 * made using the `lstUserServiceApiInstance`.
 *
 * @function
 */
lstUserServiceApiInstance.interceptors.request.use(config => __awaiter(void 0, void 0, void 0, function* () {
  const defaultHeaders = yield getAuthHeaders();
  return Object.assign(Object.assign({}, config), {
    headers: Object.assign(Object.assign({}, defaultHeaders), config.headers),
    params: Object.assign({}, config.params)
  });
}));

/**
 * An Axios instance configured with the base URL for the SSO Auth SAPI API.
 * This instance can be used to make HTTP requests to the SSO Auth SAPI API endpoints.
 *
 * @constant
 * @type {AxiosInstance}
 */
const auth0ApiInstance = axios.create({
  baseURL: getAuth0BaseUrl()
});

axiosRetry(axios, {
  retries: 1,
  retryDelay: retryCount => retryCount * 1000,
  shouldResetTimeout: true,
  retryCondition: error => {
    var _a, _b;
    const isPostOrPutRequest = ['post', 'put'].includes((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.method);
    const is404Response = ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 404;
    return !(isPostOrPutRequest || is404Response);
  },
  onRetry: (retryCount, error, requestConfig) => {
    const {
      status
    } = (error === null || error === void 0 ? void 0 : error.response) || {};
    const {
      url
    } = requestConfig || {};
    console.error('ON Error retry: ', JSON.stringify({
      retryCount,
      statusCode: status,
      url
    }));
  }
});
const getAxiosInstance = context => {
  switch (context) {
    case ApiContext.OUTLIER_API:
      return outlierApiInstance;
    case ApiContext.AUTH0_API:
      return auth0ApiInstance;
    case ApiContext.SSO_AUTH_SAPI_SERVICE:
      return ssoAuthSapiApiInstance;
    case ApiContext.LST_USER_SERVICE:
      return lstUserServiceApiInstance;
    default:
      return outlierApiInstance;
  }
};
/**
 * Sends a GET request to the specified URL using the appropriate Axios instance based on the provided context.
 *
 * @template R - The expected response type.
 * @param {string} url - The URL to send the GET request to.
 * @param {object} [params={}] - Optional query parameters to include in the request.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to determine which Axios instance to use.
 * @param {object} [extraHeaders] - Optional additional headers to include in the request.
 * @returns {Promise<R>} - A promise that resolves to the response data of type R.
 */
const get = (url, params = {}, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {
  cache: false
}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  const requestOptions = Object.assign({
    headers: extraHeaders
  }, config);
  if (!isEmpty(params)) {
    requestOptions.params = params;
  }
  return yield api.get(url, requestOptions);
});
/**
 * Sends a POST request to the specified URL with the given data and headers.
 *
 * @template R - The expected response type.
 * @param {string} url - The URL to send the POST request to.
 * @param {object} [data={}] - The data to be sent in the body of the POST request.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to use for the request.
 * @param {object} [extraHeaders] - Additional headers to include in the request.
 * @returns {Promise<R>} - A promise that resolves to the response of the POST request.
 */
const post = (url, data = {}, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {
  cache: false
}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  return yield api.post(url, data, Object.assign({
    headers: extraHeaders
  }, config));
});
/**
 * Sends a PUT request to the specified URL with the given data and headers.
 *
 * @template R - The expected response type.
 * @param {string} url - The URL to send the PUT request to.
 * @param {object} [data={}] - The data to be sent in the PUT request body.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to use for the request.
 * @param {object} [extraHeaders] - Additional headers to include in the request.
 * @returns {Promise<R>} - A promise that resolves to the response of the PUT request.
 */
const put = (url, data = {}, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  return yield api.put(url, data, Object.assign({
    headers: extraHeaders
  }, config));
});
/**
 * Sends a DELETE request to the specified URL using the provided API context and optional extra headers.
 *
 * @template R - The expected response type.
 * @param {string} url - The URL to send the DELETE request to.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to use for the request.
 * @param {object} [extraHeaders] - Optional additional headers to include in the request.
 * @returns {Promise<R>} - A promise that resolves to the response of the DELETE request.
 */
const deleteRequest = (url, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  return yield api.delete(url, Object.assign({
    headers: extraHeaders
  }, config));
});
/**
 * Uploads a CSV file to the specified URL using the appropriate Axios instance.
 *
 * @template R - The expected response type.
 * @param {string} url - The URL to upload the CSV file to.
 * @param {File | Blob} file - The CSV file to upload.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to use for the request.
 * @param {object} [extraHeaders] - Additional headers to include in the request.
 * @param {AxiosRequestConfig} [config] - Additional Axios config options.
 * @returns {Promise<R>} - A promise that resolves to the response of the upload request.
 */
const uploadCsv = (url, file, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  const formData = new FormData();
  formData.append('file', file);
  return yield api.post(url, formData, Object.assign({
    headers: Object.assign({
      'Content-Type': 'multipart/form-data'
    }, extraHeaders)
  }, config));
});
/**
 * Downloads a CSV file from the specified URL using the appropriate Axios instance.
 *
 * @param {string} url - The URL to download the CSV file from.
 * @param {object} [params={}] - Optional query parameters to include in the request.
 * @param {ApiContext} [context=ApiContext.OUTLIER_API] - The API context to use for the request.
 * @param {object} [extraHeaders] - Additional headers to include in the request.
 * @param {AxiosRequestConfig} [config] - Additional Axios config options.
 * @returns {Promise<Blob>} - A promise that resolves to the downloaded CSV file as a Blob.
 */
const downloadCsv = (url, params = {}, context = ApiContext.OUTLIER_API, extraHeaders = {}, config = {}) => __awaiter(void 0, void 0, void 0, function* () {
  const api = getAxiosInstance(context);
  const requestOptions = Object.assign({
    headers: Object.assign({
      Accept: 'text/csv'
    }, extraHeaders),
    responseType: 'blob'
  }, config);
  if (!isEmpty(params)) {
    requestOptions.params = params;
  }
  const response = yield api.get(url, requestOptions);
  return response.data;
});

export { APPLICATION_JSON, AUTH0_TOKEN, AUTH_SCOPE, ApiContext, AuthProviderType, CONTENT_TYPE, IS_COOKIE_STORE, IS_SSO_USER, LST_API_CACHE_IDB, LST_API_CACHE_IDB_VERSION, LST_API_CACHE_METHODS, LST_API_CACHE_STORAGE_TTL, LST_AUTH_TOKEN, LST_AUTH_TOKEN_EXPIRATION, LstApiCacheStorageType, OUTLIER_API_CACHE_STORAGE_TTL, OutlierApiConfig, SET_COOKIE_OPTIONS, SSO_SERVICE_TICKET, SSO_USER_ID, SapiApiConfig, UserApiConfig, X_AUTHORIZATION, X_AUTH_PROVIDER, X_USER_EMAIL, clearAllCacheStoages, clearLstApiCache, deleteRequest, downloadCsv, get, getAuth0BaseUrl, getAuth0Client, getAuth0Token, getAuthHeaders, getAuthToken, getAuthTokenFromStore, getAxiosInstance, getLstApiCacheStorageType, getLstUserServiceBaseURL, getOutlierApiBaseURL, getOutlierApiHeaders, getOutlierApiPath, getServiceTicket, getSsoAuthSapiBaseURL, getSsoUserId, getStaticHeaders, getTokenExpiration, initLstApiCacheStorage, isCookieStore, post, put, setupLstApiCache, uploadCsv, useLstApiCacheStore, useLstAuthTokenStore };
